// Age gate for the EdBrowser AI chatbot.
// Same rule as ISAFE Direct (direct_alone/frontend-react/src/util/ageGate.js).

export const MINIMUM_AGE = 13;

// Returns true only for a real calendar date (rejects e.g. Feb 30).
export const isValidDob = ({ year, month, day }) => {
  if (!year || !month || !day) return false;
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === Number(year) &&
    date.getMonth() === Number(month) - 1 &&
    date.getDate() === Number(day)
  );
};

export const calculateAge = ({ year, month, day }) => {
  const now = new Date();
  let age = now.getFullYear() - year;
  const m = now.getMonth() + 1 - month;
  if (m < 0 || (m === 0 && now.getDate() < day)) {
    age--;
  }
  return age;
};

export const meetsMinimumAge = (dob) =>
  isValidDob(dob) && calculateAge(dob) >= MINIMUM_AGE;
